import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=5538364a&"
import script from "./CustomIcon.vue?vue&type=script&lang=ts&"
export * from "./CustomIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports